import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { DefaultLayoutProps } from '@type/layout';
import { AWS_IMAGE_URL } from '@library/Constants';
import { useRecoilState } from 'recoil';
import { pageInputChange } from '@src/recoil/common';
import Header from './Header';
import LayoutMenu from './LeftMenu';

function DefaultLayout(props: DefaultLayoutProps) {
  const { children, title, backUrl, message, wrapClassName, titleCenter } = props;
  const { pathname } = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [isPageInputChange, setIsPageInputChange] = useRecoilState(pageInputChange);

  const onMenu = (flag: boolean) => {
    setMenuOpen(flag);
  };

  const goBack = (message?: string) => {
    if (message) {
      if (!isPageInputChange) {
        window.history.back();
        return;
      }
      if (!window.confirm(message)) return;
    }
    window.history.back();
  };

  useEffect(() => {
    setIsPageInputChange(false);
  }, [pathname]);

  const handleInputChange = () => {
    setIsPageInputChange(true);
  };

  return (
    <div id="layoutWrap" className="layoutWrap" onInput={handleInputChange}>
      <div className="container">
        <Header
          title={title}
          onMenu={onMenu}
          backUrl={backUrl}
          message={message}
          messageShow={isPageInputChange}
          titleCenter={titleCenter}
        />
        <div className="contentWrap">
          <LayoutMenu menuOpen={menuOpen} onMenu={onMenu} />
          <main id="content" className={`content ${wrapClassName}`}>
            <div className="titleWrap">
              {backUrl && (
                <button type="button" onClick={() => goBack(message)}>
                  <img src={`${AWS_IMAGE_URL}/icon/m-icon-20-back.svg`} className="menu" alt="back" />
                </button>
              )}
              <h2>{title}</h2>
            </div>
            {children}
          </main>
        </div>
      </div>
    </div>
  );
}

export default DefaultLayout;
